import { images } from "../../../Assets/assetsHelper";
import "./LessonDetails.css";
import React, { useContext, useEffect, useState } from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import DeleteForm from "../../../Components/Molecules/DeleteForm/DeleteForm";
import { userContext } from "../../../Contexts/userContext";
import TextArea from "../../../Components/Atoms/Inputs/TextArea/TextArea";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolIcon from "@mui/icons-material/School";
import DescriptionIcon from "@mui/icons-material/Description";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CloseIcon from "@mui/icons-material/Close";
import { MoonLoader } from "react-spinners";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import useDelete from "../../../Hooks/useDelete";
import { BaseURL, courseURL } from "../../../Hooks/URL";
import NumbersIcon from "@mui/icons-material/Numbers";
import DownloadIcon from "@mui/icons-material/Download";
import PreviewIcon from "@mui/icons-material/Preview";
import FilePreviewModal from "../../../Components/Organisms/FilePreviewModal/FilePreviewModal";

function LessonDetails({ lesson, setLesson, url, setGo, loading, courseId }) {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  const [previewAttachment, setPreviewAttachment] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  if (loading) {
    return (
      <div className="mainContainer">
        <div className="loadingContainer">
          <MoonLoader color="#012369" size={40} />
        </div>
      </div>
    );
  }

  const handleDownloadAttachment = (attachment) => {
    // Create download link for the attachment
    const downloadUrl = `${BaseURL}/${attachment.filePath}`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = attachment.name || "attachment";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePreviewAttachment = (attachment) => {
    setPreviewAttachment(attachment);
    setIsPreviewOpen(true);
  };

  const closePreview = () => {
    setPreviewAttachment(null);
    setIsPreviewOpen(false);
  };

  return (
    <div className="mainContainer">
      {lesson && (
        <>
          {/* Action Buttons */}
          {contextData?.role == "admin" && (
            <div className="courseActions">
              <button
                className="actionButton primary"
                onClick={() =>
                  navigate(`/programs/${courseId}/lessons/add/${lesson?.id}`)
                }
              >
                Edit Lesson
              </button>
              <DeleteForm
                setGo={setGo}
                title={"Are you sure to delete this lesson?"}
              />
            </div>
          )}

          {/* lesson Header Section */}
          <div className="contentSection">
            <div className="courseHeader">
              <div className="courseIconSection">
                <div className="titleIcon">
                  <MenuBookIcon />
                </div>
              </div>
              <div className="courseBasicInfo">
                <h1 className="courseName">{lesson.title}</h1>
              </div>

              <div className="courseStats">
                <div className="statItem">
                  <NumbersIcon className="statIcon" />
                  <span className="statLabel">Lesson Number</span>
                  <span className="statValue">{lesson.number || 0}</span>
                </div>
                <div
                  className="statItem clickable"
                  onClick={() => {
                    const attachmentsSection =
                      document.getElementById("attachments");
                    attachmentsSection?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  <AttachFileIcon className="statIcon" />
                  <span className="statLabel">Attachments</span>
                  <span className="statValue">
                    {lesson.attachments?.length || 0}
                  </span>
                </div>
              </div>
            </div>

            <h2 className="sectionTitle">Lesson Details</h2>
            <div className="infoGrid">
              <div className="infoItem">
                <div className="infoLabel">
                  <DescriptionIcon className="infoIcon" />
                  Content
                </div>
                <div className="infoValue descriptionText">
                  {lesson.content || "No content available"}
                </div>
              </div>
            </div>
          </div>

          {/* Attachments Section */}
          {lesson.attachments && lesson.attachments.length > 0 && (
            <div className="contentSection" id="attachments">
              <h2 className="sectionTitle">Lesson Attachments</h2>
              <div className="attachmentsGrid" style={{ marginTop: "20px" }}>
                {lesson.attachments.map((attachment, index) => (
                  <div key={index} className="attachmentCard">
                    <div className="attachmentIcon">
                      <AttachFileIcon />
                    </div>
                    <div className="attachmentInfo">
                      <h4 className="attachmentName">{attachment.name}</h4>
                    </div>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        className="actionButton secondary"
                        onClick={() => handlePreviewAttachment(attachment)}
                        title="Preview attachment"
                        style={{
                          padding: "12px",
                          minWidth: "auto",
                          fontSize: "18px",
                          background: "rgba(59, 130, 246, 0.1)",
                          color: "#3b82f6",
                          border: "1px solid rgba(59, 130, 246, 0.2)",
                        }}
                      >
                        <PreviewIcon />
                      </button>
                      {contextData?.role == "admin" && (
                        <button
                          className="actionButton primary"
                          onClick={() => handleDownloadAttachment(attachment)}
                          title="Download attachment"
                          style={{
                            padding: "12px",
                            minWidth: "auto",
                            fontSize: "18px",
                          }}
                        >
                          <DownloadIcon />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}

      {/* File Preview Modal */}
      <FilePreviewModal
        attachment={previewAttachment}
        isOpen={isPreviewOpen}
        onClose={closePreview}
        baseURL={BaseURL}
      />
    </div>
  );
}

export default LessonDetails;
